module.exports = __webpack_public_path__ + "img/clicks.70a3a311.svg";